import React, {PureComponent} from "react"
import {DataProxy, Query, pagination} from "@irati/utils/services/apollo"
import {QueryResult} from "@irati/utils/apollo"
import {gql} from "@irati/utils/gql"
import {DocumentNode} from "graphql"

import {Reward} from "../../types"

interface RewardsVariables {
  limit?: number
  offset?: number
  tags?: string[]
  status?: string
  sortBy?: string
  sortDir?: string
  isCreditOnly?: boolean
  locale: string
}

export interface RewardsData {
  rewardCatalogueRewards: {
    results: Reward[]
    count: number
  }
}

export type RewardsQuery = DataProxy.Query<RewardsVariables>
export interface RewardsResult extends QueryResult<RewardsData, RewardsVariables> {
  onLoadMore: () => Promise<RewardsQuery>
}

interface Props {
  query: DocumentNode
  children: (result: RewardsResult) => React.ReactNode
  variables: RewardsVariables
  useLoader?: boolean
  useError?: boolean
}

const query = gql`
  query RewardCatalogueRewards(
    $limit: Int
    $offset: Int
    $status: String
    $tags: [String]
    $sortBy: String
    $sortDir: String
    $isCreditOnly: Boolean
    $locale: String
    $rewardsForMyPackage: Boolean
  ) {
    rewardCatalogueRewards(
      limit: $limit
      offset: $offset
      status: $status
      tags: $tags
      sortBy: $sortBy
      sortDir: $sortDir
      isCreditOnly: $isCreditOnly
      locale: $locale
      rewardsForMyPackage: $rewardsForMyPackage
    ) {
      results {
        uuid
        urlSlug
        header
        bannerImage
        cardImage
        thumbnailImage
      }
      count
      total
    }
  }
`

class ApolloRewardsQuery extends Query<RewardsData, RewardsVariables> {}

export default class RewardsQueryComponent extends PureComponent<Props> {
  static defaultProps = {
    query,
    notifyOnNetworkStatusChange: true,
    useLoader: true,
    useError: true
  }

  render() {
    const {children, ...props} = this.props

    return (
      <ApolloRewardsQuery {...props}>
        {(apolloState) => {
          const onLoadMore = () =>
            pagination(
              {
                query,
                variables: props.variables
              },
              apolloState
            )
          return children({...apolloState, onLoadMore})
        }}
      </ApolloRewardsQuery>
    )
  }
}
